/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Perm_RosterInputs */

const en_team_perm_roster = /** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roster Access (Scanner)`)
};

const es_team_perm_roster = /** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a la Lista (Escáner)`)
};

const fr_team_perm_roster = /** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès à la liste (Scanner)`)
};

const de_team_perm_roster = /** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf Liste (Scanner)`)
};

const id_team_perm_roster = /** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Daftar Hadir (Pemindai)`)
};

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const ja_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const zh_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const ar_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const it_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const ru_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const pt_team_perm_roster = en_team_perm_roster;

/** @type {(inputs: Team_Perm_RosterInputs) => LocalizedString} */
const ko_team_perm_roster = en_team_perm_roster;

/**
* | output |
* | --- |
* | "Roster Access (Scanner)" |
*
* @param {Team_Perm_RosterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_perm_roster = /** @type {((inputs?: Team_Perm_RosterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Perm_RosterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_perm_roster(inputs)
	if (locale === "es") return es_team_perm_roster(inputs)
	if (locale === "fr") return fr_team_perm_roster(inputs)
	if (locale === "de") return de_team_perm_roster(inputs)
	if (locale === "ja") return ja_team_perm_roster(inputs)
	if (locale === "zh") return zh_team_perm_roster(inputs)
	if (locale === "ar") return ar_team_perm_roster(inputs)
	if (locale === "id") return id_team_perm_roster(inputs)
	if (locale === "it") return it_team_perm_roster(inputs)
	if (locale === "ru") return ru_team_perm_roster(inputs)
	if (locale === "pt") return pt_team_perm_roster(inputs)
	return ko_team_perm_roster(inputs)
});